import firebase from 'firebase/app'


/**
 * Edit attribute of an user object
 * @param {String} userId - The id of the user
 * @param {Values} values - List of editable fields
 * @returns {Promise}
 */
const editUser = async (userId, values = {}) => {
  const {
    tags = [],
  } = values

  const db = firebase.firestore()
  return db
    .collection('users')
    .doc(userId)
    .update({
      tags,
    })
}


export default editUser
